import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  button: {
    marginBlockStart: 25,
    [theme.breakpoints.down("md")]: {
      margin: "15px 0px 15px 0px",
    },
  },
  icon: {
    "& path": {
      color: "#22D9BB",
    },
  },
  startText: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(16),
    textAlign: "center",
  },
  assessmentContainer: {
    marginBlock: "37px 0px",
    paddingInline: 30,
    alignSelf: "center",
    [theme.breakpoints.down("md")]: {
      paddingInline: 0,
      marginBlock: "15px 0px",
    },
  },
  italic: {
    color: "#45547C",
    fontFamily: "Lato",
    fontStyle: "italic",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
    marginBlockStart: 23,
    [theme.breakpoints.down("md")]: {
      marginBlockStart: 0,
    },
  },
}));
